module.exports = __webpack_public_path__ + "static/media/5.96a6204a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格选中态/5.png
// module id = 1631
// module chunks = 0